export function font(element, binding) {
    element.classList.add('font-directive-controlled');
    const {family, color, size, lineHeight, weight, textAlign, textTransform} = binding.value;

    if (family) {
        element.dataset.family = family;
    } else if (element.dataset.family) {
        delete element.dataset.family;
    }

    if (color) {
        // Try for a named variable, fall back to the actual value.
        element.style.color = `var(--${color}, ${color})`;
    }

    element.style.fontSize = size;
    element.style.lineHeight = lineHeight;
    element.style.fontWeight = weight;
    element.style.textAlign = textAlign;
    element.style.textTransform = textTransform;
};
